import React, { useContext } from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { ButtonExtendedProps } from 'grommet';
import { AppHostContext } from '../../../services/appHost';
import SHDText from '@ui/Text/SHDText';
import SHDButton from '@ui/Button/SHDButton';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';
import { LiveStreamSettingsModal } from '../LiveStreamSettingsModal';

interface Props {
  onLinkFacebookClick: () => void;
  onCloseIntroModal: () => void;
  fbScopes: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  responseFacebook: (res: any) => Promise<void>;
  setShowHowToSetUpModal: (show: boolean) => void;
  setShowIntroModal: (show: boolean) => void;
}

export const FacebookSettingsModal: React.FC<Props> = ({
  onLinkFacebookClick,
  onCloseIntroModal,
  fbScopes,
  responseFacebook,
  setShowHowToSetUpModal,
  setShowIntroModal,
}) => {
  const appHost = useContext(AppHostContext);
  const isHosted = appHost.isHosted;

  const handleFacebookLogin = (renderProps: {
    onClick: ButtonExtendedProps['onClick'];
  }) => (
    <SHDButton
      secondary
      label={
        <SHDText size="button" style="subhead-bold" textAlign="center">
          Yes, I have live stream set up
        </SHDText>
      }
      onClick={
        renderProps.onClick as (e: React.MouseEvent<HTMLElement>) => void
      }
    />
  );

  const handleClick = async () => {
    await onLinkFacebookClick();
    setShowIntroModal(false);
  };

  return (
    <SHDThemeOverride full={false}>
      <LiveStreamSettingsModal
        headerText="LINK FACEBOOK"
        title="Have you ever livestreamed on Facebook?"
        onCloseModal={onCloseIntroModal}
      >
        {isHosted ? (
          <SHDButton
            secondary
            label="Yes, I have live stream set up"
            onClick={handleClick}
          />
        ) : (
          <FacebookLogin
            disableMobileRedirect
            version="15.0"
            appId={import.meta.env.VITE_APP_FACEBOOK_APP_ID}
            fields="name,email,picture,link"
            scope={fbScopes}
            callback={responseFacebook}
            render={handleFacebookLogin}
          />
        )}
        <SHDButton
          secondary
          label={
            <SHDText size="button" style="subhead-bold" textAlign="center">
              No, I need help setting up
            </SHDText>
          }
          onClick={() => setShowHowToSetUpModal(true)}
        />
      </LiveStreamSettingsModal>
    </SHDThemeOverride>
  );
};
